import React from "react";
import { ReactComponent as VisaLogo } from "../assets/logoVisa.svg";
import { ReactComponent as MastercardLogo } from "../assets/logoMastercard.svg";
import { ReactComponent as AmexLogo } from "../assets/logoCreditCardAmex.svg";
import { ReactComponent as GenericCardLogo } from "../assets/creditCard.svg";

export interface CardType {
  displayName: string;
  Logo: React.FC<React.SVGProps<SVGSVGElement>>;
}

const VISA: CardType = {
  displayName: "Visa",
  Logo: VisaLogo,
};

const MASTERCARD: CardType = {
  displayName: "Mastercard",
  Logo: MastercardLogo,
};

const AMEX: CardType = {
  displayName: "Amex",
  Logo: AmexLogo,
};

// Fallback for any issuer we don't have a dedicated logo for.
const GENERIC: CardType = {
  displayName: "Card",
  Logo: GenericCardLogo,
};

export const cardTypes = { VISA, MASTERCARD, AMEX };

/**
 * The exact string the backend sends for `PaymentToken.issuer` isn't
 * documented anywhere we have access to, so matching is intentionally
 * loose (case-insensitive, substring) rather than an exact-string switch —
 * an exact match would silently fall back to the generic icon for every
 * real card over something as small as a casing difference.
 */
export const getCardType = (issuer?: string | null): CardType => {
  const normalized = issuer?.trim().toLowerCase() ?? "";

  if (!normalized) return GENERIC;
  if (normalized.includes("visa")) return VISA;
  if (normalized.includes("mastercard") || normalized.includes("master card")) {
    return MASTERCARD;
  }
  if (normalized.includes("amex") || normalized.includes("american express")) {
    return AMEX;
  }

  return GENERIC;
};
